var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_825_2976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4998 4H19.3332V5.33333H21.3332V20H2.66651V5.33333H4.66651V4H2.49985C2.344 4.0026 2.1902 4.03588 2.04722 4.09794C1.90425 4.15999 1.77489 4.24961 1.66655 4.36166C1.55821 4.47371 1.47301 4.60601 1.41581 4.751C1.35861 4.89599 1.33053 5.05083 1.33318 5.20667V20.1267C1.33053 20.2825 1.35861 20.4373 1.41581 20.5823C1.47301 20.7273 1.55821 20.8596 1.66655 20.9717C1.77489 21.0837 1.90425 21.1733 2.04722 21.2354C2.1902 21.2974 2.344 21.3307 2.49985 21.3333H21.4998C21.6557 21.3307 21.8095 21.2974 21.9525 21.2354C22.0954 21.1733 22.2248 21.0837 22.3331 20.9717C22.4415 20.8596 22.5267 20.7273 22.5839 20.5823C22.6411 20.4373 22.6692 20.2825 22.6665 20.1267V5.20667C22.6692 5.05083 22.6411 4.89599 22.5839 4.751C22.5267 4.60601 22.4415 4.47371 22.3331 4.36166C22.2248 4.24961 22.0954 4.15999 21.9525 4.09794C21.8095 4.03588 21.6557 4.0026 21.4998 4Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 9.3335H6.66683V10.6668H5.3335V9.3335Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 9.3335H10.6668V10.6668H9.3335V9.3335Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 9.3335H14.6668V10.6668H13.3335V9.3335Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 9.3335H18.6668V10.6668H17.3335V9.3335Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 12.6665H6.66683V13.9998H5.3335V12.6665Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 12.6665H10.6668V13.9998H9.3335V12.6665Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 12.6665H14.6668V13.9998H13.3335V12.6665Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 12.6665H18.6668V13.9998H17.3335V12.6665Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 16H6.66683V17.3333H5.3335V16Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 16H10.6668V17.3333H9.3335V16Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 16H14.6668V17.3333H13.3335V16Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 16H18.6668V17.3333H17.3335V16Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 6.66683C6.84348 6.66683 7.01305 6.59659 7.13807 6.47157C7.2631 6.34654 7.33333 6.17697 7.33333 6.00016V2.00016C7.33333 1.82335 7.2631 1.65378 7.13807 1.52876C7.01305 1.40373 6.84348 1.3335 6.66667 1.3335C6.48986 1.3335 6.32029 1.40373 6.19526 1.52876C6.07024 1.65378 6 1.82335 6 2.00016V6.00016C6 6.17697 6.07024 6.34654 6.19526 6.47157C6.32029 6.59659 6.48986 6.66683 6.66667 6.66683Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 6.66683C17.51 6.66683 17.6796 6.59659 17.8046 6.47157C17.9296 6.34654 17.9998 6.17697 17.9998 6.00016V2.00016C17.9998 1.82335 17.9296 1.65378 17.8046 1.52876C17.6796 1.40373 17.51 1.3335 17.3332 1.3335C17.1564 1.3335 16.9868 1.40373 16.8618 1.52876C16.7367 1.65378 16.6665 1.82335 16.6665 2.00016V6.00016C16.6665 6.17697 16.7367 6.34654 16.8618 6.47157C16.9868 6.59659 17.1564 6.66683 17.3332 6.66683Z",
    fill: "#726F95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 4H15.3332V5.33333H8.6665V4Z",
    fill: "#726F95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_825_2976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ee00a4020a176b467d7c360376eec98e.svg";
export { ForwardRef as ReactComponent };